import green from 'Images/cusgreen.svg';
import blue from 'Images/cusblue.svg';
import red from 'Images/cusred.svg';
import yellow from 'Images/cusyellow.svg';
import gray from 'Images/cusgray.svg';
import padUnlocked from 'Images/padlock-unlockedLock.svg';
import padLocked from 'Images/padlock-lockedLock.svg';

export default {
  green,
  blue,
  red,
  yellow,
  gray,
  padUnlocked,
  padLocked,
};

